import { Group } from '@visx/group';

import type { HierarchyPointNode } from '../../types';

import { VisxText } from '@/components/VisxText';

import { useTheme } from 'styled-components';

type Props = {
  node: HierarchyPointNode;
};

export const Ticker = ({ node }: Props) => {
  const theme = useTheme();
  return (
    <Group top={node.x} left={node.y + theme.x1spacePx}>
      <VisxText
        typography="xSmall"
        verticalAnchor="middle"
        fill={theme.color.white}
      >
        {node.data.name}
      </VisxText>
    </Group>
  );
};
